import { render, staticRenderFns } from "./press.vue?vue&type=template&id=93bbf7d0&scoped=true&lang=pug"
import script from "./press.vue?vue&type=script&lang=ts"
export * from "./press.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93bbf7d0",
  null
  
)

export default component.exports